import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCollaborationSidebarState, makeGetShouldShowCommentPopOverForAsset } from 'ContentEditorUI/redux/selectors/collaborationSidebarSelectors';
import { UPDATE_COLLABORATION_SIDEBAR_STATE } from 'ContentEditorUI/redux/actions/actionTypes';
import ControlledEmbeddedCommentPopover from 'collaboration-sidebar/features/deepCommenting/components/ControlledEmbeddedCommentPopover';
import { MSG_TYPE_CREATE_COMMENT_IN_CACHE } from 'collaboration-sidebar/constants/IFrameMessageTypes';

// @ts-expect-error not yet migrated
import { setDirtyFlag } from 'ContentEditorUI/redux/actions/appActions';
import usePrevious from 'react-utils/hooks/usePrevious';
import { layoutSectionHoverPositionsFrozen, layoutSectionHoverPositionsThawed
// @ts-expect-error not yet migrated
} from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { toggleCollaborationSidebarCommentPopover } from 'ContentEditorUI/redux/actions/collaborationSidebarActions';
import { jsx as _jsx } from "react/jsx-runtime";
const useCommentPopoverOpenState = id => {
  const dispatch = useDispatch();
  const showCommentPopOver = useSelector(makeGetShouldShowCommentPopOverForAsset(id));
  const prevShowCommentPopOver = usePrevious(showCommentPopOver);
  const toggleCommentPopover = useCallback(isOpen => {
    dispatch(toggleCollaborationSidebarCommentPopover({
      id,
      isOpen
    }));
  }, [dispatch, id]);
  useEffect(() => {
    if (showCommentPopOver !== prevShowCommentPopOver) {
      // Since the comment popover is attached to the hover overlay toolbar, we
      // need to freeze the hover positions so that the toolbar doesn't get
      // unmounted
      if (showCommentPopOver) {
        dispatch(layoutSectionHoverPositionsFrozen());
      } else {
        dispatch(layoutSectionHoverPositionsThawed());
      }
    }
  }, [dispatch, prevShowCommentPopOver, showCommentPopOver]);
  return {
    showCommentPopOver,
    toggleCommentPopover
  };
};
export default function PopoverWithDeepComment({
  id,
  description,
  children,
  shouldSaveOnComment
}) {
  const collaborationSidebarState = useSelector(getCollaborationSidebarState);
  const dispatch = useDispatch();
  const {
    showCommentPopOver,
    toggleCommentPopover
  } = useCommentPopoverOpenState(id);
  const onUpdateCollaborationSidebarState = useCallback(updates => {
    const isNewCommentCreated = updates.broadcastCommentMessage && updates.broadcastCommentMessage.type === MSG_TYPE_CREATE_COMMENT_IN_CACHE;
    dispatch({
      type: UPDATE_COLLABORATION_SIDEBAR_STATE,
      payload: updates
    });
    if (shouldSaveOnComment && isNewCommentCreated) {
      //force save to make sure BE saves persistent editorId
      dispatch(setDirtyFlag(true));
    }
  }, [dispatch, shouldSaveOnComment]);
  return /*#__PURE__*/_jsx(ControlledEmbeddedCommentPopover, {
    moduleId: id,
    description: description,
    collaborationSidebarState: collaborationSidebarState,
    onUpdateCollaborationSidebarState: onUpdateCollaborationSidebarState,
    onOpenChange: toggleCommentPopover,
    isOpen: showCommentPopOver,
    popoverPlacement: "bottom right",
    children: children
  });
}